import DataBinder from "../DataBinder.js";
import SwapPage from "../SwapPage.js";

export default class FindServerContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "FindServer";
  }

  show(path, model = {}) {
    const pageId = this.pageId;
    const app = this.app;
    const userdata = app.userdata;

    let isLoggedIn = userdata && userdata.id;
    if (!isLoggedIn) {
      app.navigate("Login");
      return;
    }
  
    app.populate(pageId, model);
    app.swapPage(pageId);

    this.connect(app.userdata);
  }
  connect(userdata) {
    const app = this.app;
    let serverUrl = userdata.serverUrl;
    app.gameServer.connectAsync(userdata, serverUrl)
      .then(function () {
        app.navigate("Online");
      }.bind(this))
      .catch(function (err) {
        app.navigate("MainMenu");
        app.createNotification("Failed to connect to server");
      }.bind(this));
  }
}
